import { render, staticRenderFns } from "./RoomTypeSettingTab.vue?vue&type=template&id=a8f243ee&scoped=true&lang=pug"
import script from "./RoomTypeSettingTab.vue?vue&type=script&lang=ts"
export * from "./RoomTypeSettingTab.vue?vue&type=script&lang=ts"
import style0 from "./RoomTypeSettingTab.vue?vue&type=style&index=0&id=a8f243ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f243ee",
  null
  
)

export default component.exports